require('smooth-scroll')('a[href*="#"]', {
  speed: 200,
})
